import { Component, ChangeDetectionStrategy, input, computed, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-sayac',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sayac-kapsayici">
      <span class="sayac-deger" [style.color]="renk()">{{ gosterimDeger() }}</span>
      <div class="sayac-alt">
        @if (deltaYuzde() !== null) {
          <span class="trend" [class.yukselis]="deltaYuzde()! > 0" [class.dusus]="deltaYuzde()! < 0">
            {{ deltaYuzde()! > 0 ? '▲' : deltaYuzde()! < 0 ? '▼' : '—' }}
            {{ absDelta() }}%
          </span>
        }
        <span class="etiket-metin">{{ etiket() }}</span>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .sayac-kapsayici { text-align: center; padding: 8px 0; }
    .sayac-deger {
      font-size: 36px; font-weight: 700; line-height: 1.1;
      display: inline-block;
      transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    .sayac-alt { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 4px; }
    .trend {
      font-size: 13px; font-weight: 600; padding: 2px 6px; border-radius: 4px;
      transition: color 0.2s, background 0.2s;
    }
    .trend.yukselis { color: #52c41a; background: rgba(82, 196, 26, 0.1); }
    .trend.dusus { color: #f5222d; background: rgba(245, 34, 45, 0.1); }
    .etiket-metin { font-size: 13px; opacity: 0.65; }
  `],
})
export class SayacComponent {
  deger = input(0);
  oncekiDeger = input(0);
  etiket = input('');
  renk = input('#1890ff');

  gosterimDeger = computed(() => {
    const d = this.deger();
    return d >= 1000 ? (d / 1000).toFixed(1) + 'K' : String(d);
  });

  deltaYuzde = computed(() => {
    const onceki = this.oncekiDeger();
    if (!onceki) return null;
    return Math.round(((this.deger() - onceki) / onceki) * 100);
  });

  absDelta = computed(() => Math.abs(this.deltaYuzde() ?? 0));
}
